import { Badge } from "@/components/ui/badge";
import type { DealStatus } from "@/api/client";

// CHP-411: partner-facing (BDM/PO) ledger badge copy. The review-pending states
// read as "<thing> in review" and a declined registration as "Registration
// Declined" (was the bare "Declined") so the partner can tell what was declined.
const COPY: Record<DealStatus, string> = {
  draft: "Draft",
  pending_review: "Registration in review",
  live: "Live",
  denied: "Registration Declined",
  closed_lost: "Closed-Lost",
  extension_pending: "Extension in review",
  win_pending_review: "Closed-won in review",
  closed_won: "Closed-Won",
};

const VARIANT: Record<DealStatus, "default" | "outline" | "secondary" | "destructive" | "success"> =
  {
    draft: "outline",
    pending_review: "secondary",
    live: "success",
    denied: "destructive",
    closed_lost: "destructive",
    extension_pending: "secondary",
    win_pending_review: "secondary",
    closed_won: "success",
  };

export function DealStatusBadge({ status }: { status: DealStatus }) {
  return <Badge variant={VARIANT[status]}>{COPY[status]}</Badge>;
}
